import { Division, Flex, Heading, Icon, Icons, Paragraph } from "@ir/ui";
import { activeCountLabel } from "./activeCountLabel";

export const BrandDetailsFeaturesHeader = ({
  activeFeaturesCount,
}: {
  activeFeaturesCount: number;
}) => {
  const label = activeCountLabel(
    activeFeaturesCount,
    "feature",
    "Features",
  );

  return (
    <Flex align="center">
      <Icon name={Icons.Settings} color="primary" />
      <Division style={{ marginLeft: "1rem", flex: 1 }}>
        <Heading level={6} className="text-grey-700 font-bold m-0">
          Features
        </Heading>
        <Paragraph
          className="text-grey-500 font-regular m-0"
          style={{ fontSize: "0.8rem" }}
        >
          {label}
        </Paragraph>
      </Division>
    </Flex>
  );
};
